// extracted by mini-css-extract-plugin
export default {"layoutSelector":"LayoutSelector_layoutSelector__SO9Nx"};